<template>
  <chart-canvas :option="option" :empty="empty" />
</template>

<script>
import ChartCanvas from "./ChartCanvas.vue";
import { leadBarOption } from "./chart-options";

export default {
  name: "LeadTrendChart",
  components: { ChartCanvas },
  props: { trend: { type: Array, default: () => [] } },
  computed: {
    empty() {
      return !this.trend.length;
    },
    option() {
      return leadBarOption(this.trend);
    },
  },
};
</script>
